/* eslint-disable import/prefer-default-export */
export const APPEND_WORKSHOP_ONGOING_VISITS = 'APPEND_WORKSHOP_ONGOING_VISITS';
export const GET_WORKSHOP_ONGOING_VISITS = 'GET_WORKSHOP_ONGOING_VISITS';
